<template>
  <div class="comment-list">
    <ul>
      <li v-for="item in list" :key="item.id">
        <img class="avatar" :src="item.avatar" />
        <div class="contents">
          <div class="info">
            <span class="sp1">
              <span>{{item.nickname}}</span>
              <span>评价</span>
            </span>
            <font>{{item.course||item.book||item.name}}</font>
            <Rate disabled v-model="item.grade" />
            <span
              class="sp2"
            >{{new Date(parseInt(item.created_at)*1000).format("yyyy-MM-dd hh:mm:ss")}}</span>
          </div>
          <div class="label" v-if="hasLabel">
            <span v-for="(it,idx) in item.comment_tag" :key="idx">{{it}}</span>
          </div>
          <p class="article">{{item.content}}</p>
        </div>
        <p class="delete">
          <span @click="deleteCom(item.id)">删除</span>
        </p>
      </li>
    </ul>
    <div class="pager">
      <Page
        class="f-right"
        show-total
        @on-page-size-change="pageSizeChange"
        @on-change="changePage"
        :total="total"
        show-elevator
        show-sizer
        transfer
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    search: {
      type: Object
    },
    dataUrl: {
      type: String
    },
    method: {
      type: String,
      default: "get"
    },
    hasLabel: {
      type: Boolean,
      default: false
    },
    formatter: {
      type: Function
    },
    deleteHandler: {
      type: Function
    }
  },
  data() {
    return {
      page: 1,
      limit: 10,
      total: 0,
      valueDisabled: 2,
      list: []
    };
  },
  methods: {
    getData(refresh) {
      if (refresh) {
        this.page = 1;
      }
      let obj = {
        page: this.page,
        limit: this.limit,
        ...this.search
      };
      this.$http[this.method](this.dataUrl, obj).then(res => {
        res.list.forEach(item => {
          if (item.comment_tag) item.comment_tag = item.comment_tag.split(",");
          if (this.formatter) {
            this.formatter(item);
          }
        });
        this.list = res.list;
        this.total = res.total;
      });
    },
    pageSizeChange(d) {
      this.limit = d;
      this.getData(true);
    },
    changePage(d) {
      this.page = d;
      this.getData(false);
    },
    searchRefresh() {
      this.getData(true);
    },
    deleteCom(id) {
      this.$Modal.confirm({
        title: "删除",
        content: "<p>确定要删除该评论吗？</p>",
        onOk: () => {
          this.del(id);
        },
        onCancel: () => {}
      });
    },
    del(id) {
      if (this.deleteHandler) {
        this.deleteHandler(id);
      } else {
        this.$http.delete(`${this.dataUrl}/${id}`).then(() => {
          this.searchRefresh();
        });
      }
    }
  },
  created() {
    this.getData(true);
  }
};
</script>

<style lang="scss" scoped>
.comment-list {
  font-family: Arial, Helvetica, sans-serif;
  .no-comment {
    text-align: center;
    height: 90px;
    line-height: 90px;
    font-size: 14px;
  }
  ul {
    overflow: hidden;
    padding: 0 10px 30px;
    li {
      border: 1px solid rgb(223, 218, 218);
      border-radius: 5px;
      display: flex;
      margin-top: 20px;
      padding: 30px 0;
      .avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-left: 30px;
        margin-right: 20px;
        flex: none;
      }
      .contents {
        display: flex;
        flex-direction: column;
        flex: 1;
        .info {
          display: flex;
          align-items: center;
          .sp1 {
            font-size: 17px;
            color: #333;
            margin-right: 20px;
          }
          .sp2 {
            font-size: 14px;
            color: #999;
            margin-left: 30px;
          }
          font {
            font-size: 14px;
            color: #2d8cf0;
            margin-right: 30px;
          }
        }
        .label {
          span {
            display: inline-block;
            padding: 0 8px;
            font-size: 12px;
            color: #333;
            margin-right: 10px;
            margin-top: 6px;
            border: 1px solid #ccc;
            background: #f8f8f8;
            border-radius: 4px;
          }
        }
        .article {
          margin-top: 10px;
          font-size: 15px;
          color: #333;
          width: 90%;
          word-break: break-all;
        }
      }
      .delete {
        width: 100px;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #2d8cf0;
        span {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
